import React from "react";
import { Fade } from "react-reveal";

const skillGroups = [
  {
    label: "Languages",
    items: ["TypeScript", "JavaScript", "Python", "SQL"],
  },
  {
    label: "Backend",
    items: [
      "Node.js",
      "NestJS",
      "Express.js",
      "REST APIs",
      "Microservices",
      "Event-Driven Architecture",
      "Multi-Tenant Design",
      "Redis",
      "Bull / BullMQ",
      "Message Queues",
      "Webhooks",
      "JWT",
      "OAuth2",
      "Serverless",
    ],
  },
  {
    label: "Frontend",
    items: ["React.js", "Redux", "TypeScript"],
  },
  {
    label: "Cloud and DevOps",
    items: [
      "AWS Lambda",
      "API Gateway",
      "CloudFormation",
      "Azure Functions",
      "App Services",
      "Service Bus",
      "Blob Storage",
      "Docker",
      "Azure DevOps",
      "CI/CD",
      "Git",
    ],
  },
  {
    label: "Databases",
    items: ["PostgreSQL", "MySQL", "Azure SQL", "Redis", "DuckDB", "Parquet"],
  },
  {
    label: "Testing",
    items: ["Jest", "Postman", "Newman"],
  },
  {
    label: "GenAI",
    items: [
      "RAG",
      "Azure OpenAI",
      "Pinecone",
      "Vector Search",
      "Embeddings",
      "LangChain",
    ],
  },
];

const About = () => {
  return (
    <div
      style={{ background: "#0b0b0d", color: "white" }}
      className="main-div"
      id="about"
    >
      <Fade left cascade>
        <section className="div-1 about">
          <h1 className="heading">About Me</h1>
          <div>
            <p className="text mt-4 mb-3">
              Senior Software Engineer with 5+ years of experience building
              backend systems and full-stack products in Node.js, NestJS,
              TypeScript, and React.js.
            </p>
            <p className="text my-3">
              I work as a{" "}
              <span className="accent">Senior Software Engineer</span> at{" "}
              <span className="accent">
                Nitor Infotech, an Ascendion company
              </span>
              . My work is strongest on microservices, API performance, and
              multi-tenant design, with production systems on Azure and AWS. I
              also built a multi-tenant RAG platform with Azure OpenAI and
              Pinecone.
            </p>
          </div>
          <p className="text mt-3">Technologies I work with:</p>
          <div className="skill-groups">
            {skillGroups.map((group) => (
              <div className="skill-group" key={group.label}>
                <h2>{group.label}</h2>
                <ul className="chips">
                  {group.items.map((item) => (
                    <li className="chip" key={item}>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>
      </Fade>
    </div>
  );
};

export default About;
